import React from 'react';
import { NavLink } from 'react-router-dom';
import './Style.css'; // Import the CSS file for styling
import logo from './assets/logo.png'; // Import the logo
import Form from 'react-bootstrap/Form';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-overlay">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="navbar-logo">
                            <img src={logo} alt="Logo" className="navbar-logo-img" />
                        </div>
                        <p>Centric aplications productize before front end vortals visualize front end is results and value added</p>
                        <h4>WE ARE AVAILABLE</h4>
                        <p>MON-FRI: 09.00 AM TO 6.30 PM</p>
                    </div>
                    <div className="footer-section">
                        <h4>Useful Links</h4>
                        <ul>
                            <li><NavLink to="/about">About Us</NavLink></li>
                            <li><NavLink to="/portfolio">Our Portfolio</NavLink></li>
                            <li><NavLink to="/services">Our Service</NavLink></li>
                            <li><NavLink to="/contact">Contact Us</NavLink></li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h4>Contact Us</h4>
                        <p>webdev@dotlocalhost.com</p>
                        <p><a href="tel:+923162003961" style={{color:'#ffffff', textDecoration:'none'}}>+1 209 213 3438</a></p>
                        <p>6026 Fair Oaks Blvd, Carmichael, California, 95608, United States</p>
                    </div>
                    <div className="footer-section">
                        <h4>Subscribe newsletter</h4>
                        <Form>
                            <div className='row'>
                                <div className='col-8'>
                                    <input type="email" placeholder="Enter Yor Email" />
                                </div>
                                <div className='col-4'>
                                    <button className="btn footer-button">Submit</button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2025 <NavLink to="/" style={{textDecoration:'none', fontWeight:'700'}}>DotLocalHost</NavLink>. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
